import { db } from "@/firebase";
import dayjs from "dayjs";

async function getDocumentByRef(docRef) {
  return new Promise((resolve, reject) => {
    docRef
      .get()
      .then(doc => {
        if (doc.exists) {
          const data = doc.data();
          data.id = doc.id;
          resolve(data);
        } else {
          reject(docRef.path + " does not exist.");
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function getSettings(uid) {
  console.assert(uid, "Expecting uid");
  const docRef = db.collection("settings").doc(uid);
  return getDocumentByRef(docRef);
}

export async function getUser(uid) {
  console.assert(uid, "Expecting uid");
  const docRef = db.collection("users").doc(uid);
  return getDocumentByRef(docRef);
}

export async function updateUser(uid, data) {
  console.assert(uid, "Expecting uid");
  await db
    .collection("users")
    .doc(uid)
    .update(data);
}

export async function getClient(clientId) {
  console.assert(clientId, "Expecting clientId");
  const docRef = db.collection("clients").doc(clientId);
  return getDocumentByRef(docRef);
}

export async function getClients() {
  const clients = [];
  return new Promise((resolve, reject) => {
    db.collection("clients")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const data = doc.data();
            data.id = doc.id;
            clients.push(data);
          }
        });
        resolve(clients);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function getCustomer(customerId) {
  console.assert(customerId, "Expecting customerId");
  const docRef = db.collection("customers").doc(customerId);
  return getDocumentByRef(docRef);
}

export async function updateCustomer(customerId, data) {
  console.assert(customerId, "Expecting customerId");
  await db
    .collection("customers")
    .doc(customerId)
    .update(data);
}

export async function getCustomization(customerId) {
  console.assert(customerId, "Expecting customerId");
  const refCustomer = db.collection("customers").doc(customerId);
  const docCustomer = await getDocumentByRef(refCustomer);
  const refCustomization = db
    .collection("customizations")
    .doc(docCustomer.customization);
  return getDocumentByRef(refCustomization);
}

export async function getCustomizations() {
  const customizations = [];
  return new Promise((resolve, reject) => {
    db.collection("customizations")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const data = doc.data();
            data.id = doc.id;
            customizations.push(data);
          }
        });
        resolve(customizations);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function getIndustries(customerId) {
  console.assert(customerId, "Expecting customerId");
  const refCustomer = db.collection("customers").doc(customerId);
  const docCustomer = await getDocumentByRef(refCustomer);
  const refCustomization = db
    .collection("customizations")
    .doc(docCustomer.customization);
  const industries = [];
  return new Promise((resolve, reject) => {
    refCustomization
      .collection("industries")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            industries.push(doc.data());
          }
        });
        resolve(industries);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function getBasket(basketId) {
  console.assert(basketId, "Expecting basketId");
  const docRef = db.collection("baskets").doc(basketId);
  return getDocumentByRef(docRef);
}

export async function getBasketItems(basketId) {
  console.assert(basketId, "Expecting basketId");
  const items = [];
  return new Promise((resolve, reject) => {
    db.collection("baskets")
      .doc(basketId)
      .collection("items")
      .orderBy("timestamp")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const item = doc.data();
            item.id = doc.id;
            items.push(item);
          }
        });
        resolve({ items });
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function addBasket(data) {
  return new Promise((resolve, reject) => {
    db.collection("baskets")
      .add(data)
      .then(docRef => {
        resolve(docRef.id);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function deleteBasket(basketId) {
  console.assert(basketId, "Expecting basketId");
  await db
    .collection("baskets")
    .doc(basketId)
    .delete();
}

export async function updateBasket(basketId, data) {
  console.assert(basketId, "Expecting basketId");
  await db
    .collection("baskets")
    .doc(basketId)
    .update(data);
}

export async function addItemToBasket(basketId, item) {
  console.assert(basketId, "Expecting basketId");
  item.timestamp = Date.now();
  return new Promise((resolve, reject) => {
    db.collection("baskets")
      .doc(basketId)
      .collection("items")
      .add(item)
      .then(docRef => {
        resolve(docRef.id);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function updateBasketItem(basketId, itemId, data) {
  console.assert(basketId, "Expecting basketId");
  await db
    .collection("baskets")
    .doc(basketId)
    .collection("items")
    .doc(itemId)
    .update(data);
}

export async function deleteBasketItem(basketId, itemId) {
  console.assert(basketId, "Expecting basketId");
  await db
    .collection("baskets")
    .doc(basketId)
    .collection("items")
    .doc(itemId)
    .delete();
}

export async function writeOrder(data) {
  return new Promise((resolve, reject) => {
    db.collection("orders")
      .add(data)
      .then(docRef => {
        resolve(docRef.id);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function getOrderIdByShopOrderNo(shopOrderNo) {
  console.assert(shopOrderNo, "Expecting shopOrderNo");
  const orderIds = [];
  return new Promise((resolve, reject) => {
    db.collection("orders")
      .where("shopOrderNo", "==", shopOrderNo)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          orderIds.push(doc.id);
        });
        resolve(orderIds.length ? orderIds[0] : null);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function getOrderList(customerId, minTimestamp, filterDays) {
  console.assert(customerId, "Expecting customerId");
  const today = new Date();
  const dateFrom = dayjs(today)
    .subtract(filterDays, "day")
    .toISOString()
    .substring(0, 10);
  const orderList = [];
  return new Promise((resolve, reject) => {
    db.collection("customers")
      .doc(customerId)
      .collection("orderstatus")
      .where("orderDate", ">=", dateFrom)
      .orderBy("orderDate", "desc")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            orderList.push(doc.data());
          }
        });
        resolve(
          orderList.filter(
            o => o.timestamp >= minTimestamp && o.filterDays >= filterDays
          )
        );
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function getOrderHead(customerId, orderNo) {
  console.assert(customerId, "Expecting customerId");
  const docRef = db
    .collection("customers")
    .doc(customerId)
    .collection("orderstatus")
    .doc(orderNo);
  return getDocumentByRef(docRef);
}

export async function getOrderItems(customerId, orderNo, minTimestamp) {
  console.assert(customerId, "Expecting customerId");
  console.assert(orderNo, "Expecting orderNo");
  const items = [];
  return new Promise((resolve, reject) => {
    db.collection("customers")
      .doc(customerId)
      .collection("orderstatus")
      .doc(orderNo)
      .collection("items")
      .where("timestamp", ">=", minTimestamp)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            items.push(doc.data());
          }
        });
        resolve(items);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function getOrdersMissingResult() {
  const orders = [];
  return new Promise((resolve, reject) => {
    db.collection("ordersMissingResult")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const data = doc.data();
            data.id = doc.id;
            orders.push(data);
          }
        });
        resolve(orders);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function getCustomerAddresses(customerId, collection) {
  console.assert(customerId, "Expecting customerId");
  const addresses = [];
  return new Promise((resolve, reject) => {
    db.collection("customers")
      .doc(customerId)
      .collection(collection)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const data = doc.data();
            data.id = doc.id;
            addresses.push(data);
          }
        });
        resolve(addresses);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function addCustomerAddress(customerId, collection, data) {
  console.assert(customerId, "Expecting customerId");
  return new Promise((resolve, reject) => {
    db.collection("customers")
      .doc(customerId)
      .collection(collection)
      .add(data)
      .then(docRef => {
        resolve(docRef.id);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function updateCustomerAddress(customerId, collection, id, data) {
  console.assert(customerId, "Expecting customerId");
  console.assert(collection, "Expecting collection");
  console.assert(id, "Expecting address id");
  await db
    .collection("customers")
    .doc(customerId)
    .collection(collection)
    .doc(id)
    .update(data);
}

export async function deleteCustomerAddress(customerId, collection, id) {
  console.assert(customerId, "Expecting customerId");
  console.assert(collection, "Expecting collection");
  console.assert(id, "Expecting address id");
  await db
    .collection("customers")
    .doc(customerId)
    .collection(collection)
    .doc(id)
    .delete();
}

export async function getNewShopOrderNo(clientId) {
  console.assert(clientId, "Expecting clientId");
  const docRef = db.collection("clients").doc(clientId);
  return new Promise((resolve, reject) => {
    db.runTransaction(trans => {
      return trans.get(docRef).then(doc => {
        if (!doc.exists) {
          throw docRef.path + " does not exist.";
        }
        const { sequences } = doc.data();
        const newShopOrderNo = sequences.shopOrderNo
          ? Number.parseInt(sequences.shopOrderNo) + 1
          : 200001;
        trans.update(docRef, { "sequences.shopOrderNo": newShopOrderNo });
        return newShopOrderNo;
      });
    })
      .then(value => {
        resolve(value);
      })
      .catch(error => {
        reject(error);
      });
  });
}
